import React, { useEffect, useMemo, useCallback } from 'react';
import { Colors } from '../colors';
import { useBrandKitState } from '../../store';
import { BrandKitWrapper, ImportExportButton } from './styled';
import { MediaType } from '../../common/types';
import { Fonts } from '../fonts';
import { Stickers } from '../logos-stickers';
import { Logos } from '../logos';
import { Divider } from '@unfold/divider';
import { SmallOptionsMenuIcon } from '@unfold/icon';
import { Modal } from '@unfold/modal';
import ImportExportModal from './ImportExportModal';

export const BrandKit: React.FC = () => {
  const [state, actions] = useBrandKitState();

  useEffect(() => {
    actions.load();
  }, []);

  const colors = useMemo(
    () => state.mediaItems.filter((media) => media.type === MediaType.Color),
    [state.mediaItems]
  );

  const stickers = useMemo(
    () => state.mediaItems.filter((media) => media.type === MediaType.Sticker),
    [state.mediaItems]
  );

  const logos = useMemo(
    () => state.mediaItems.filter((media) => media.type === MediaType.Logo),
    [state.mediaItems]
  );

  const fonts = useMemo(
    () => state.mediaItems.filter((media) => media.type === MediaType.Font),
    [state.mediaItems]
  );

  const handleImportExportClick = useCallback((): void => actions.openImportExportModal(), [actions.openImportExportModal]);
  const handleModalClose = useCallback((): void => actions.closeImportExportModal(), [actions.closeImportExportModal]);

  return (
    <>
      <BrandKitWrapper>
        <ImportExportButton
          appearance="bordered"
          width={30}
          height={30}
          onClick={handleImportExportClick}
        >
          <SmallOptionsMenuIcon />
        </ImportExportButton>
        <Colors colors={colors} isLoading={state.loading} />
        <Divider space={32} />
        <Logos logos={logos} isLoading={state.loading} />
        <Divider space={32} />
        <Fonts fonts={fonts} isLoading={state.loading} />
        <Divider space={32} />
        <Stickers stickers={stickers} isLoading={state.loading} />
      </BrandKitWrapper>
      <Modal
        isOpen={state.isImportExportModalOpen}
        onClose={handleModalClose}
        width={350}
        title="Brand kit"
      >
        <ImportExportModal />
      </Modal>
    </>
  );
};
